import React from 'react'
import Blog1 from "../../assets/img/nosotros/mision.jpg"
import Blog2 from "../../assets/img/nosotros/vision.jpg"
import Blog3 from "../../assets/img/nosotros/filosofia.jpg"

function Latest() {
  return (
    <>
        <section id="blog" className="blog-area p-relative fix pt-90 pb-90">
                <div className="container">
                    <div className="row align-items-center"> 
                        <div className="col-lg-12">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                 <h5>Nuestro Nombre</h5>
                                <h2>
                                Hotel La Finca 
                                </h2>
                                <p>En el contexto histórico de México, las haciendas eran grandes propiedades agrícolas y
ganaderas que incluían extensos terrenos de cultivo, áreas de producción y viviendas para
trabajadores. Dentro de estas haciendas, existían fincas, que eran secciones más
pequeñas pero importantes, generalmente destinadas a la producción específica de algún
producto (como pulque, café o ganado), o incluso como residencias para los propietarios o
administradores.&quot;</p>
                            </div>                           
                        </div>
                    </div>
                    <div className="row">
                       <div className="col-lg-4 col-md-6">
                            <div className="single-post2 hover-zoomin mb-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="blog-thumb2">
                                    <img src={Blog1} alt="img"/>
                                </div>                    
                                <div className="blog-content2">    
                                    <div className="date-home">
                                    MISIÓN
                                    </div>
                                    <h4>Crear una experiencia de hospedaje confortable y moderna</h4> 
                                    <p>Fusionando la elegancia contemporánea con la esencia colonial de la región a través riqueza cultural e histórica de la altiplanicie pulquera.</p>
                                    {/* <div className="blog-btn"><Link to="/blog-details">Read More</Link></div> */}
                                     
                                </div>
                            </div>
                        </div>
                         <div className="col-lg-4 col-md-6">
                            <div className="single-post2 mb-30 hover-zoomin wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="blog-thumb2">
                                    <img src={Blog2} alt="img"/>
                                </div>
                                <div className="blog-content2">                                    
                                    <div className="date-home">
                                       VISIÓN
                                    </div>
                                    <h4>Ser el referente en hospitalidad en la región</h4> 
                                    <p>Ofreciendo una experiencia de alojamiento que
combina historia, cultura y modernidad. Nos enfocamos en brindar un servicio de alta
calidad, con atención personalizada y espacios diseñados para ejecutivos, empresas y
viajeros que buscan comodidad, elegancia y autenticidad.</p>
                                    {/* <div className="blog-btn"><Link to="/blog-details">Read More</Link></div> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="single-post2 mb-30 hover-zoomin wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="blog-thumb2">
                                    <img src={Blog3} alt="img"/>
                                </div>
                                <div className="blog-content2">                                    
                                    <div className="date-home">
                                        FILOSOFÍA
                                    </div>
                                    <h4>Fusionar la modernidad con la riqueza histórica y
                                    cultural de la región</h4> 
                                    <p>Ofreciendo a nuestros huéspedes un espacio donde el confort y la
                                    identidad local conviven en armonía.</p>
                                    {/* <div className="blog-btn"><Link to="/blog-details">Read More</Link></div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
        </section>
        
    </>
  )
}

export default Latest